const TRACKING_NUMBER_REGEX = /^\d{12}$/;

export function normalizeTrackingNumber(value: string) {
  return value.replace(/\D+/g, '').slice(0, 12);
}

export function isValidTrackingNumber(value: string) {
  return TRACKING_NUMBER_REGEX.test(value);
}

export function buildTrackingNotFoundMessage(trackingNumber: string) {
  return `No shipment found for tracking number "${trackingNumber}". Please verify the number on your order confirmation and try again.`;
}